import React, { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import videoCircle from "../Assets/Images/Dashboard/video_progress_circle.svg";
import performanceCircle from "../Assets/Images/Dashboard/performance_circle.png";
import { AVERAGE_PROGRESS_GET_API } from "../Component/AllApi";
const AverageProgress = () => {
  const [chartData, setChartData] = useState([]);

  // useEffect(() => {
  //   setChartData([
  //     { month: "Jan", average: 40, trialData: 20 },
  //     { month: "Feb", average: 20, trialData: 30 },
  //     { month: "Mar", average: 60, trialData: 50 },
  //     { month: "Apr", average: 80, trialData: 90 },
  //     { month: "May", average: 20, trialData: 60 },
  //     { month: "Jun", average: 40, trialData: 20 },
  //     { month: "Jul", average: 60, trialData: 50 },
  //     { month: "Aug", average: 10, trialData: 30 },
  //     { month: "Sep", average: 60, trialData: 50 },
  //     { month: "Oct", average: 20, trialData: 30 },
  //     { month: "Nov", average: 60, trialData: 50 },
  //     { month: "Dec", average: 80, trialData: 90 },
  //   ]);
  // }, []);

  const [data, setData] = useState([]);
  const token = localStorage.getItem("authToken");
  const fetchData = async () => {
    try {
      let response = await fetch(AVERAGE_PROGRESS_GET_API, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
        },
      });
      if (response.ok) {
        const responseData = await response.json();
        // console.log("graph data: ", responseData);
        setData(responseData.monthly_data);
        setChartData(
          responseData.monthly_data.map((entry) => ({
            ...entry,
            monthYear: `${entry.month}-${entry.year}`,
          }))
        );
        // setProgressData(data);
      }
    } catch (err) {
      console.error("Error occured ", err);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [token]);

  // console.log("data :", data);

  return (
    <>
      <section className="averageProgress">
        <p className="main_title mt-5">Average Progress and Performance</p>
        <div className="mt-4 ">
          <div className="backgroundDiv" style={{ width: "100%" }}>
            <span className="chartInfo" style={{ float: "right" }}>
              <span className="videoProgressCircle">
                <img src={videoCircle} alt="videoCircle" />
              </span>
              <span className="videoProgressTitle ms-2 me-2">
                Video Progress
              </span>
              <span className="performanceCircle">
                <img src={performanceCircle} alt="performanceCircle" />
              </span>
              <span className="performanceTitle ms-2">Performance</span>
            </span>
            <ResponsiveContainer aspect={3}>
              <BarChart
                data={chartData}
                barCategoryGap="10%"
                stackOffset="expand"
              >
                {/* <XAxis dataKey="month"
                /> */}
                <XAxis
                  dataKey="monthYear"
                  tick={{
                    fontSize: "0.8em",
                    fontWeight: "bold",
                  }}
                  interval={0}
                  tickLine={false}
                  axisLine={false}
                />

                <YAxis
                  domain={[0, 100]}
                  tickFormatter={(value) => `${value}%`}
                />
                <Bar
                  dataKey="vid_percentage"
                  fill="#EDB652"
                  radius={[10, 10, 10, 10]}
                />
                <Bar
                  dataKey="performance_percentage"
                  fill="#F8E2BA"
                  radius={[10, 10, 10, 10]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </section>
    </>
  );
};

export default AverageProgress;
